// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

import App from "./App";
import "./styles/global.css";

// Poly‑fill for any packages that need Node's Buffer
import { Buffer } from "buffer";
window.Buffer = Buffer;

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HelmetProvider>
      {/* App already contains <BrowserRouter> */}
      <App />
    </HelmetProvider>
  </React.StrictMode>
);
